// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9269 ? "0b7b90cd" : chunkId) + "." + {"5721":"0842c459f90d1fdb","7665":"5ae786a739bd9de3","9269":"9341876813340721"}[chunkId] + ".js";
};